module.exports = __webpack_public_path__ + "img/40_00_078_430.87cec0ec.jpg";